import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Symbol } from "@api";
import { WizardsHeader } from "@rentablo/components";
import { SecuritiesSearch } from "@features/transactionWizard/components/SecuritySearch";
import { WizardLayout } from "@rentablo/components";

export const SearchSecurityPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClickCloseWizard = () => {
    navigate(`/`);
  };

  const handleSelectSymbol = (symbol: Symbol) => {
    const params = new URLSearchParams();
    if (symbol.id) params.set("id", symbol.id);
    if (symbol.quoteProvider) params.set("quoteProvider", symbol.quoteProvider);
    navigate({ pathname: "/securities", search: params.toString() });
  };

  return (
    <WizardLayout
      width={800}
      header={
        <WizardsHeader
          title={t("searchSecurityPage.title")}
          onBackClick={handleClickCloseWizard}
        />
      }
    >
      <SecuritiesSearch onSymbolSelect={handleSelectSymbol} showManual />
    </WizardLayout>
  );
};
